import { jsx as _jsx } from "react/jsx-runtime";
import { PlainButton, Text } from '@bos/ui';
import { redirectToUrlOpenNewTab } from '@bos/utils';
import { useSnackbarConfig } from '../../../context/SnackbarConfigContext/SnackbarConfigContext';
export const SnackbarActionButton = ({ actionButtonText, externalLink, internalNavigateOptions, }) => {
    const { navigate } = useSnackbarConfig();
    const handleActionClick = () => {
        if (externalLink) {
            redirectToUrlOpenNewTab(externalLink);
        }
        else if (internalNavigateOptions) {
            navigate(internalNavigateOptions);
        }
    };
    return (_jsx(PlainButton, { type: 'button', onClick: handleActionClick, children: _jsx(Text, { variant: 'b2', color: 'white', underline: true, children: actionButtonText }) }));
};
